import { SupplierBillsListView } from "@medicorepay/ui";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import {
  PurchaseInvoiceStatus,
  purchaseInvoiceService,
} from "../../services/purchase-invoice.service";

export function SupplierBillsPage() {
  const navigate = useNavigate();
  const loadBills = useCallback(
    (params?: { status?: PurchaseInvoiceStatus }) =>
      purchaseInvoiceService.list(params),
    [],
  );

  return (
    <SupplierBillsListView
      loadBills={loadBills}
      onOpen={(id) => navigate(`/supplier-bills/${id}`)}
      onReceiveStock={() => navigate("/goods-receipts/new")}
    />
  );
}
